import { createRouter, createWebHistory } from "vue-router";
import { globalVariable } from '../services/globalVariable'; 

import { useLocalStorage } from '@vueuse/core';



import AnasayfaView from "../views/AnasayfaView.vue";
import LoginView from "../views/LoginView.vue";
import ProfilView from "../views/ProfilView.vue";


    import KullanicilarView from "../views/kullanicilar/KullanicilarView.vue";
	import KullanicilarDetayView from "../views/kullanicilar/KullanicilarDetayView.vue";

    import RollerView from "../views/roller/RollerView.vue";
	import RollerDetayView from "../views/roller/RollerDetayView.vue";

    import FirmalarView from "../views/firmalar/FirmalarView.vue";
	import FirmalarDetayView from "../views/firmalar/FirmalarDetayView.vue";


    import KisilerView from "../views/kisiler/KisilerView.vue";
	import KisilerDetayView from "../views/kisiler/KisilerDetayView.vue";

    import EtkinliklerView from "../views/etkinlikler/EtkinliklerView.vue";
	import EtkinliklerDetayView from "../views/etkinlikler/EtkinliklerDetayView.vue";

    import GorusmebilgilerView from "../views/gorusmebilgiler/GorusmebilgilerView.vue";
    import GorusmeFormView from "../views/gorusmebilgiler/GorusmeFormView.vue";
    import HizliGorusmeFormView from "../views/gorusmebilgiler/HizliGorusmeFormView.vue";
    import TabletFormView from "../views/gorusmebilgiler/TabletFormView.vue";

	import GorusmebilgilerDetayView from "../views/gorusmebilgiler/GorusmebilgilerDetayView.vue";
	import YedeklerView from "../views/YedeklerView.vue";


    const routes = [{
            path: "/login",
            name: "Login",
            component: LoginView,
        },
        {
            path: "/",
            name: "anasayfailk",
            component: AnasayfaView,
        },
        {
            path: "/anasayfa",
            name: "anasayfa",
            component: AnasayfaView,
        },
        {
            path: "/profil",
            name: "profil",
            component: ProfilView,
        },
        {
            path: "/kullanicilar",
            name: "kullanicilar",
            component: KullanicilarView,
        },

        {
            path: '/kullanicilar/:id/:tab?',
            name: 'kullanicilardetay',
            component: KullanicilarDetayView,
            beforeEnter: (to, from, next) => {
              // tab parametresini kontrol et
              if (!to.params.tab) {
                // tab parametresi belirtilmemişse, varsayılan değeri ata
                to.params.tab = 'bilgiler';
              }
              // Yönlendirmeyi devam ettir
              next();
            }
          },
        {
            path: "/roller",
            name: "roller",
            component: RollerView,
        },
        {
            path: '/roller/:id/:tab?',
            name: 'rollerdetay',
            component: RollerDetayView,
            beforeEnter: (to, from, next) => {
              // tab parametresini kontrol et
              if (!to.params.tab) {
                // tab parametresi belirtilmemişse, varsayılan değeri ata
                to.params.tab = 'bilgiler';
              }
              // Yönlendirmeyi devam ettir
              next();
            }
          },
        {
            path: "/firmalar",
            name: "firmalar",
            component: FirmalarView,
        },
        {
            path: '/firmalar/:id/:tab?',
            name: 'firmalardetay',
            component: FirmalarDetayView,
            beforeEnter: (to, from, next) => {
              // tab parametresini kontrol et
              if (!to.params.tab) {
                // tab parametresi belirtilmemişse, varsayılan değeri ata
                to.params.tab = 'bilgiler';
              }
              // Yönlendirmeyi devam ettir
              next();
            }
          },
      
      
        {
            path: "/kisiler",
            name: "kisiler",
            component: KisilerView,
        },
        {
            path: '/kisiler/:id/:tab?',
            name: 'kisilerdetay',
            component: KisilerDetayView,
            beforeEnter: (to, from, next) => {
              // tab parametresini kontrol et
              if (!to.params.tab) {
                // tab parametresi belirtilmemişse, varsayılan değeri ata
                to.params.tab = 'bilgiler';
              }
              // Yönlendirmeyi devam ettir
              next();
            }
          },
        {
            path: "/etkinlikler",
            name: "etkinlikler",
            component: EtkinliklerView,
        },
        {
            path: '/etkinlikler/:id/:tab?',
            name: 'etkinliklerdetay',
            component: EtkinliklerDetayView,
            beforeEnter: (to, from, next) => {
              // tab parametresini kontrol et
              if (!to.params.tab) {
                // tab parametresi belirtilmemişse, varsayılan değeri ata
                to.params.tab = 'bilgiler';
              }
              // Yönlendirmeyi devam ettir
              next();
            }
          },
        {
            path: "/gorusmebilgiler",
            name: "gorusmebilgiler",
            component: GorusmebilgilerView,
        },
        {
          path: "/gorusmeform/:id",
          name: "gorusmeform",
          component: GorusmeFormView,
      },
      {
        path: "/hizligorusmeform",
        name: "hizligorusmeform",
        component: HizliGorusmeFormView,
    },
    {
      path: "/tabletform/:id",
      name: "tabletform",
      component: TabletFormView,
  },
    
        {
          path: "/yedekler",
          name: "yedekler",
          component: YedeklerView,
      },
        {
            path: '/gorusmebilgiler/:id/:tab?',
            name: 'gorusmebilgilerdetay',
            component: GorusmebilgilerDetayView,
            beforeEnter: (to, from, next) => {
              // tab parametresini kontrol et
              if (!to.params.tab) {
                // tab parametresi belirtilmemişse, varsayılan değeri ata
                to.params.tab = 'bilgiler';
              }
              // Yönlendirmeyi devam ettir
              next();
            }
          },
        
    ];


const router = createRouter({
    history: createWebHistory(),
    routes,
});


router.beforeEach((to, from, next) => {
    // JWT kontrolünü gerçekleştirin
    globalVariable.jwtkontrol();
    
  const token=useLocalStorage('token', '');
  if (!token && token.value!=null  && to.name !== 'Login' ) {
      next({ name: 'Login' });
  } else {
      next();
  }
});

export default router;